<script setup lang="ts">
defineProps<{
  eyebrow?: string;
  title: string;
  summary: string;
  cta?: { label: string; to: string };
}>();
</script>

<template>
  <header class="border-b border-brand-900/20 bg-brand-900 text-white">
    <div class="mx-auto max-w-6xl px-4 py-16 sm:px-6 sm:py-20 lg:px-8">
      <p
        v-if="eyebrow"
        class="mb-4 text-sm font-semibold uppercase tracking-[0.16em] text-brand-200"
      >
        {{ eyebrow }}
      </p>
      <h1 class="max-w-4xl text-4xl font-bold leading-tight sm:text-5xl">
        {{ title }}
      </h1>
      <p class="mt-6 max-w-3xl text-lg leading-8 text-blue-50 sm:text-xl">
        {{ summary }}
      </p>
      <NuxtLink
        v-if="cta"
        :to="cta.to"
        class="mt-8 inline-flex min-h-11 items-center rounded-lg bg-white px-5 py-3 font-semibold text-brand-900 transition-colors hover:bg-brand-50 focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-white"
      >
        {{ cta.label }}
      </NuxtLink>
    </div>
  </header>
</template>
